export enum AuditItemTypes {
    Question = 'Question',
    Category = 'Category',
    Response = 'Response',
}